import { Check, Copy } from 'lucide-react';

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function TemplatePreviewCard(props: {
  previewJson: string;
  copied: boolean;
  onCopy: () => void;
  onSave: () => void;
  isSaving: boolean;
  canSave: boolean;
  showSave?: boolean;
}) {
  const { previewJson, copied, onCopy, onSave, isSaving, canSave, showSave = true } = props;

  return (
    <Card className="relative rounded-2xl">
      <CardHeader>
        <CardTitle>Payload Preview</CardTitle>
        <CardDescription>This is what you will store as the template record.</CardDescription>
      </CardHeader>

      <Button
        type="button"
        variant="ghost"
        size="icon"
        onClick={onCopy}
        aria-label="Copy JSON to clipboard"
        className="absolute top-4 right-4"
      >
        {copied ? <Check className="h-4 w-4 text-green-600" /> : <Copy className="h-4 w-4" />}
      </Button>

      <CardContent>
        <pre className="bg-muted max-h-96 overflow-auto rounded-xl border p-3 text-xs">{previewJson}</pre>

        {showSave ? (
          <div className="flex justify-end pt-4">
            <Button type="button" size="lg" className="min-w-[240px]" onClick={onSave} disabled={isSaving || !canSave}>
              {isSaving ? 'Saving...' : 'Save Draft'}
            </Button>
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
